import { type SecurityEventRow, useSecurityEvents } from '../../api/admin';
import { EmptyState, ErrorState, LoadingState } from '../../components/states';
import { usePageTitle } from '../../layout/shellContext';

const EVENT_LABEL: Record<SecurityEventRow['eventType'], { label: string; className: string }> = {
  login: { label: 'Вход', className: 'status-ok' },
  logout: { label: 'Выход', className: 'status-neutral' },
  access_denied: { label: 'Отказ', className: 'status-bad' },
  session_rejected: { label: 'Сессия отклонена', className: 'status-info' },
};

const describe = (row: SecurityEventRow) => {
  const reason = typeof row.details.reason === 'string' ? row.details.reason : null;
  const method = typeof row.details.method === 'string' ? row.details.method : null;
  return [row.action, row.resourceType, reason, method].filter(Boolean).join(' · ');
};

export function SecurityPage() {
  usePageTitle('Журнал безопасности');
  const events = useSecurityEvents();
  if (events.isPending) return <LoadingState label="Загружаю журнал" />;
  if (events.isError) return <ErrorState error={events.error} onRetry={() => void events.refetch()} />;
  return (
    <section className="panel">
      {events.data.items.length ? (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Когда</th>
                <th>Событие</th>
                <th>Кто</th>
                <th>Подробности</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {events.data.items.map((row) => (
                <tr key={row.id}>
                  <td className="number">{new Date(row.occurredAt).toLocaleString('ru-RU')}</td>
                  <td>
                    <span className={`status ${EVENT_LABEL[row.eventType].className}`}>
                      {EVENT_LABEL[row.eventType].label}
                    </span>
                  </td>
                  <td>{row.displayName ?? '—'}</td>
                  <td>{describe(row) || '—'}</td>
                  <td className="number">{row.ipAddress ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState title="Событий нет" />
      )}
    </section>
  );
}
